module.exports = __webpack_public_path__ + "img/pattern-orange-bg.2612bad9.jpg";